import React, { FC, ReactNode } from 'react'
import { useSelector } from 'react-redux'
import { SideBar } from './SideBar'
import { Footer } from './Footer'
import { CountdownBanner } from '../Account'
import { AppState } from '../../redux/root-reducer'
import { DraftState } from '../../redux/draft-drawer/types'
import { StyledAppLayout } from '.'
import { DraftDrawer, DraftDrawerButton } from '../DraftDrawer'

type Props = {
  children: ReactNode;
}

const AppLayout: FC<Props> = ({ children }) => {
  const { isOpened: draftOpened } = useSelector<AppState, DraftState>((state) => state.draft)

  return (
    <StyledAppLayout draftOpened={draftOpened}>
      <div className="sidebar-container">
        <SideBar />
      </div>
      <div className="app-content">
        <CountdownBanner />
        <div className="app-content-sizer">{children}</div>
        <Footer />
      </div>
      <DraftDrawer />
      <DraftDrawerButton />
    </StyledAppLayout>
  )
}

export default AppLayout
